import { DataBean } from "../DataBean";

export class EmployeeVacProvision extends DataBean {



    public async getDetailedFortnightVacProcessByAccount(accountID:any,year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDetailedFortnightVacProcessByAccount_Number_Number_Number", [accountID,year,month]);
    }

     public async deleteFortnightVacProcess(idVacProvision:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteFortnightVacProcess_Number", [idVacProvision]);
    }

     public async updateEmployeeVacProvision(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeVacProvision_updateEmployeeVacProvision_employees.EmployeeVacProvision", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "employees.EmployeeVacProvision"
            }
        ]);
    }
    
}